<template>
  <div class="term">
    <div class="term-title">オンライン健康相談実証実験サービス powered by TONE Care利用規約</div>
    <div class="term-sub-title">第１条（規約の適用）</div>
    <ol>
      <li>当社は、本規約を定め、本規約によりオンライン健康相談実証実験サービス powered by TONE Care（以下「本サービス」）を提供します。</li>
      <li>当社による本サービスの表示や別途当社が定める条件表示がある場合、当該表示は本規約の一部を構成するものとします。ただし、当該表示と本規約が抵触する場合は、当該表示が優先するものとします。</li>
      <li>本規約は、本サービスをご利用いただくにあたり、必要な事項を定めたものです。本サービスをご利用いただくには、本規約への同意が必要となります。本規約に同意いただけない場合には、本サービスをご利用いただくことはできません。また、未成年の方は、適格な法定代理人による事前の同意を得なければ、本サービスを利用することができません。</li>
      <li>ユーザーが本サイトを利用した時点を以って、本規約に基づく本サービスの利用許諾契約が成立します。</li>
    </ol>
    <div class="term-sub-title">第２条（規約の変更）</div>
    <ol>
      <li>当社は、民法548条の4第1項の定めに従い、ユーザーの承諾を得ることなく本規約を変更できるものとします。本規約を変更する場合、変更後の本規約の効力発生時期およびその内容を当社のウェブサイト上での掲示その他の適切な方法により周知し、又はユーザーに通知します。この場合、提供条件等は変更後の規約によります。</li>
      <li>ユーザーは、前項の周知があった場合、その内容を遅滞なく確認するものとします。また、ユーザーが変更された規約に同意しない場合、ユーザーはサービス利用を中断し、退会するものとします。</li>
    </ol>
    <div class="term-sub-title">第３条（用語の定義）</div>
    <div>本規約で使用する用語の意味は、それぞれ次のとおりとします。</div>
    <ol>
      <li>「当社」<br>フリービット株式会社をいいます。</li>
      <li>「ユーザー」<br>本規約に同意し、本条第５項に定める本サイトを含む本サービスを利用した方をいいます。</li>
      <li>「親族等」<br>相談を行うユーザーの親族等をいいます。</li>
      <li>「相談」<br>本サービスを用いて医師に対し行われた相談をいいます。</li>
      <li>「本サイト」<br>本サービスのシステム、アプリケーション、ウェブサイト（アプリケーション上に表示されるものを含む）を総称していいます。</li>
      <li>「相談者本人」<br>相談を行うユーザーもしくは親族等を総称していいます。</li>
      <li>「障害事由」<br>第７条第１項前段に定める場合及び相当の理由を総称していいます。</li>
      <li>「プライバシーポリシー」<br>当社の別途定める個人情報保護方針（プライバシーポリシー）をいいます。</li>
    </ol>
    <div class="term-sub-title">第４条（本サービスの目的および利用）</div>
    <ol>
      <li>本サービスは、医師に対して遠隔で健康に関する事項や医学に関わる様々な疑問に関して相談することが出来るサービスです。</li>
      <li>本サイトより本規約及び別途当社の定めるプライバシーポリシーに同意の上、当社所定の項目を入力し相談日時を予約します。予約の日時に当社指定のWEB会議システムを用い、医師と相談が出来ます。</li>
      <li>ユーザーは、ユーザーの親族等に相談を受けさせることが出来ます。ただし、相談を受けることが出来る親族等の範囲について別途当社が定める場合は、当該定めを優先します。</li>
      <li>相談者本人は、相談実施にあたり自己のプライバシーを確保できる物理的環境を整え、その環境下で相談するものとします。なお、WEB会議システムの障害やトラブル等の対応、利用方法のサポート等のため、当社は、相談者本人が相談中のWEB会議システムに入室する場合があり、この場合相談者本人は医師の指示に従い、相談を一時中止するものとします。当社は、この対応に際し相談者本人の相談内容について知ることがないよう努めるものとします。</li>
      <li>相談にあたる医師は、当社がこれを定めるものとし、相談者本人からの指定は出来ません。また、当社が関係しない医師を本サービスの相談に指定することも出来ません。</li>
      <li>本サービス及び本サービスにおける医師の回答、アドバイスは診療行為（医療行為）ではなく、あくまで相談者本人を責任主体とした自己の健康管理のための、健康相談（健康情報提供）サービスです。相談者本人は、自己の責任と判断により本サービスの利用、医療機関の受診等、自己の状態に対し適切な対応を行うものとします。</li>
    </ol>
    <div class="term-sub-title">第５条（本サービスの利用料金等）</div>
    <ol>
      <li>本サービスは無料で利用することが出来ます。</li>
      <li>本サービスの利用のために必要な環境（WEB会議システムのインストール、通信端末、通信料、通信環境、プライバシーの保護された物理的な相談環境等）については、相談者本人の責任及び費用負担にて用意するものとします。なお、WEB会議システムは多量の通信を発生させるため、ユーザー及び親族等は自らのインターネット環境（インターネットサービスプロバイダとの契約内容を含む。）について事前に確認するものとします。</li>
    </ol>
    <div class="term-sub-title">第６条（本サービスの変更、廃止）</div>
    <ol>
      <li>当社は、当社の判断により本サービスの全部又は一部を適時変更、廃止することができるものとします。</li>
      <li>本サービスを変更、廃止する際は、次条と同様の手続をとるものとします。</li>
    </ol>
    <div class="term-sub-title">第７条（当社による本サービスの提供停止）</div>
    <ol>
      <li>当社は、システムの定期保守および緊急保守のために必要な場合、停電や第三者の行為によりシステムに回復困難な損害が生じた場合、本サービスの運営状況その他の予期できない事情、その他相当の理由がある場合には、ユーザーに対してその旨を通知、又は当社ホームページもしくは本サイトへその旨を告知することにより、本サービスの全部又は一部のサービス提供を停止することができるものとします。</li>
      <li>障害事由への対応が緊急性を要し、当社が前項の通知もしくは告知を行うことが合理的でないと判断した場合、当社の判断で事前の通知及び告知の必要なく本サービスの停止を行うことができるものとします。この場合、当社は停止を行った旨を、遅滞なく、前項に則り通知もしくは告知します。</li>
      <li>当社は、ユーザーが次の各号に該当（その恐れを含む。）すると判断した場合、該当ユーザーもしくは相談者本人について本サービスの利用停止、制限、以降の本サービスの利用拒否等、当社が適切と判断する対応をすることができるものとします。また、本項における当社の判断について、当社はユーザーもしくは相談者本人に対し説明義務を負わないものとします。
        <ol class="second-list">
          <li>ユーザーや相談者本人の個人情報が第三者に利用されている疑いがある場合</li>
          <li>第８条（利用資格）第１項各号を満たさない場合</li>
          <li>第１１条（遵守事項及び禁止事項）に反する場合</li>
          <li>当社からユーザーに対し合理的手段を用いて１カ月以上連絡がとれない場合</li>
          <li>相談者本人の物理的環境について、プライバシー確保の観点から医師が不適切と判断した場合</li>
          <li>その他当社が必要と判断した場合</li>
        </ol>
      </li>
      <li>本条によりユーザーもしくは相談者本人に損害が発生した場合でも、当社は当該損害について免責されます。</li>
    </ol>
    <div class="term-sub-title">第８条（利用資格）</div>
    <ol>
      <li>本サービスの利用にあたり、ユーザーになろうとする方は次の全てを、相談者本人になろうとする方は、次の第５号乃至第１０号を満たす方とします。
        <ol class="second-list">
          <li>個人での利用であり、法人ではないこと。</li>
          <li>日本国内に在住の方であること。</li>
          <li>本規約および当社が別途定めるプライバシーポリシー等に同意頂いたこと。</li>
          <li>親族等の行為に責任を負うこと。</li>
          <li>本サービスの利用に係り、当社に提供する情報について虚偽、誤記、記入漏れがないこと。</li>
          <li>多量の通信を行うWEB会議システムの利用に懸念のないインターネット環境をお持ちの方であること。</li>
          <li>本サービス利用の目的が、本サービスの提供目的と合致していること。</li>
          <li>過去に当社により本サービスの利用資格や、当社の他のサービスの会員資格等を取り消されたことがないこと。</li>
          <li>未成年の場合において、親権者もしくは法定代理人の同意があること。</li>
          <li>成年被後見人、被保佐人又は被補助人のいずれかに該当する場合において、後見人、保佐人又は補助人の同意を得ていること。</li>
        </ol>
      </li>
      <li>前項の条件を満たさない方は、本サービスの利用はできません。</li>
    </ol>
    <div class="term-sub-title">第９条（ユーザー情報の変更等）</div>
    <ol>
      <li>ユーザーは、本サイト等を介し当社へ提供した情報（氏名、電話番号、メールアドレス等）に変更があったときは、速やかに当社所定の手続きに従い修正するものとします。</li>
      <li>前項の変更を怠ったことにより、ユーザーに対する当社からの通知が到達しない等、ユーザーが不利益を被った場合においても、当社は一切責任を負わないものとし、当社からの通知は通常到達すべきときに到達したものとみなされます。</li>
    </ol>
    <div class="term-sub-title">第１０条（通知）</div>
    <ol>
      <li>当社からユーザーへの通知は、ユーザーが当社に提供したメールアドレス宛の電子メール、本サイト内での通知、当社ホームページ上での掲載、その他当社の指定するシステムやアプリケーションでの通知等、当社が適当と判断する方法により行うものとします。</li>
      <li>前項の通知は、当社が当該通知の内容をホームページや本サイト上に表示した時点又は電子メール等が当社より発信された時点をもってユーザーに到達したものとみなし、当該到達時点から効力を生じるものとします。</li>
      <li>ユーザーは、本条の通知について速やかに確認しなければなりません。また、ユーザーが通知を受理できる環境にない場合等、当社の責めに帰すべき事由以外の通知の不達について、再通知は行いません。</li>
    </ol>
    <div class="term-sub-title">第１１条（遵守事項及び禁止事項）</div>
    <ol>
      <li>ユーザー及び親族等は、本サービスの利用にあたり、下記の事項を遵守するものとします。
        <ol class="second-list">
          <li>本サービスを自らの判断により利用し、本サービスの利用もしくはその結果に対し自ら責任を負うこと。</li>
          <li>ユーザーにおいて、相談を希望する親族等（親族等が未成年者の場合においては、その親権者を含む。）に対し本規約を確認、同意、遵守させるとともに、本サービス利用に係る親族等の行為に自ら責任を負うこと。</li>
          <li>本規約のほか、当社が別途定める本サービスに係る表示、約款、規則及び利用条件がある場合には、これに従うこと。</li>
          <li>本サービスを利用するために必要となる端末や環境（物理的・通信環境を含みます。）について、自己の費用と責任において維持すること。</li>
          <li>本サービス利用にあたり、正確、完全かつ最新の情報を当社（相談中においては医師）へ提供すること。</li>
        </ol>
      </li>
      <li>ユーザー及び親族等は、本サービスの利用にあたり、下記の事項を行ってはなりません。
        <ol class="second-list">
          <li>本サービスを、本サービスの提供目的（本規約に定めるもののほか、別途当社が定める目的がある場合、当該目的を含みます。）とは異なる目的で利用する行為。</li>
          <li>医師に対し、診断等の医療行為その他医学的判断を伴う一切の行為を求めること、診療、診察、診断、治療または処方等に関する回答もしくはアドバイス等を求めること。</li>
          <li>本サービスの営利的な使用のほか、当社もしくは医師、その他本サービスを利用する他のユーザー等への迷惑行為、強要及び脅迫行為。</li>
          <li>虚偽情報を用いての利用。</li>
          <li>当社の許可する者以外に本サービスを利用させること、相談を受けさせること。</li>
          <li>本サービスの利用権利を第三者に貸与、譲渡、またはこれらのための名義変更等を行うこと。</li>
          <li>他人の個人情報等を盗用し、又は不正に使用する行為。</li>
          <li>本サービスの利用に係り得た個人情報その他情報及び、当社の対応を第三者に開示、転載、漏洩、拡散等する行為、又は本サービスの提供目的に反し無断で使用する行為。</li>
          <li>本サービスの利用に係り得た当社の営業上、技術上、開発上その他の情報を第三者に開示又は漏洩する行為。</li>
          <li>本サービスによる相談内容や医師について、画面保存機能を用いた録画や録音、その他電磁的方法や機能を用いて記録、複写、複製等すること。</li>
          <li>不必要な予約を繰り返すこと、取り消しを前提とした予約をすること、正当な理由なくかつ事前の取り消しなく予約を放置しもしくは予約変更を繰り返すこと、その他本サービスの運営、当社もしくは医師の活動・業務を妨害する行為。</li>
          <li>本サービスの運営に係る医師もしくは当社の指示に従わないこと。</li>
          <li>本サービスの安定した運営を妨害する目的で多量の情報を伝送し、又は広告性の情報を伝送する行為。</li>
          <li>情報通信設備の誤作動や情報の破壊を誘発させるコンピュータウィルスプログラム等を流布する行為。</li>
          <li>他のユーザーを含む第三者もしくは当社に対し広告、宣伝、勧誘又は受信者が嫌悪感を抱くメッセージを送信する行為。</li>
          <li>本サービスを、第三者に再販売もしくは提供すること。</li>
          <li>他のユーザー、当社、医師、その他第三者の財産、プライバシーもしくは肖像権、パブリシティー権を侵害すること、又はそのおそれのある行為をすること。</li>
          <li>第１５条（知的財産権）に違反する行為、その他当社および医師の保有する知的財産権の侵害行為。</li>
          <li>本サービスを利用し営業行為、選挙運動、政治活動及び宗教的行為を行うこと。</li>
          <li>無限連鎖講（ネズミ講）や連鎖販売取引（マルチ商法、ネットワークビジネス等）の開設や勧誘、これらに類する行為。</li>
          <li>差別的発言、誹謗中傷、偽計及び風説、虚偽情報及び社会秩序に反する内容の発信、その他他者の信用を貶め名誉を棄損する行為。</li>
          <li>威力を示して金品等の経済的な利益を要求すること、その他不当要求もしくは過剰要求をすること。</li>
          <li>法令（個人情報保護、児童ポルノ、ポルノ、わいせつ物の頒布等を規制する法令を含むがこれに限らない）に反する行為、犯罪を助長する行為。</li>
          <li>国益又は社会的利益を妨害する目的でサービスの利用を計画もしくは実行する行為。</li>
          <li>上記各号の他、法令又は公序良俗に違反する行為。</li>
          <li>その他、当社が合理的な理由に基づき不適切と判断する行為。</li>
        </ol>
      </li>
    </ol>
    <div class="term-sub-title">第１２条（権利義務譲渡の禁止）</div>
    <div class="indent">ユーザー及び親族等は、本サービスの地位、本サービスから生じる権利義務について、第三者に譲渡（有償無償を問いません。）や転売、担保に供することはできません。</div>
    <div class="term-sub-title">第１３条（個人情報）</div>
    <ol>
      <li>ユーザー及び親族等（親族等が未成年者の場合においては、その親権者を含む。）は、プライバシーポリシー<a href="https://freebit.com/privacypolicy/" target="_blank">https://freebit.com/privacypolicy/</a>へも同意の上、本サービスを利用するものとします。プライバシーポリシーに同意されない場合、本サービスを利用することは出来ません。</li>
      <li>当社は、プライバシーポリシーに定める項目のほか、以下の通り個人情報を取得します。なお、本項に定めのない事項はプライバシーポリシーに準じます。
        <div class="top-padding">【利用目的】</div>
        <ol class="second-list">
          <li>本サービスをユーザーもしくは親族等に円滑に提供するため</li>
          <li>医師が精度の高い相談対応をするため、医師間の効率的な引継ぎのため</li>
          <li>サービスの障害等の調査・対応のため</li>
          <li>ユーザーや親族等から本サービス自体についての相談、お問い合わせへの対応ため</li>
          <li>本サービスの利用状況の分析・調査・品質改善・ユーザーや親族等への対応向上、施策の効果測定のため</li>
          <li>ユーザーや親族等のウェルビーイング （Well-being、幸福・健康）等を実現するための分析検討と、新規サービス・商品の開発、提供、広告、促進のため</li>
        </ol>
        <div class="top-padding">【取得する情報の項目】</div>
        <ol class="second-list">
          <li>ユーザー及び相談者本人の氏名・性別・年齢</li>
          <li>体温・症状報告内容</li>
          <li>出勤・在宅・休日等の予定</li>
          <li>滞在場所・時間（相談者本人の就業場所に当社指定の位置情報取得デバイス、ビーコンを設置している場合、これにより得られる情報）  </li>
          <li>コロナワクチン接種状況  （ただし相談者本人が当社及びフリービットスマートワークス株式会社に所属する場合に限る）</li>
          <li>業務時間（勤怠打刻）（ただし相談者本人が当社及びフリービットスマートワークス株式会社に所属する場合に限る）</li>
          <li>座席履歴（ただし相談者本人が当社及びフリービットスマートワークス株式会社に所属する場合に限る）</li>
          <li>健康相談日時・相談時間</li>
          <li>予約時の相談者情報（名前・性別・年代・連絡先）</li>
          <li>予約時の相談カテゴリー、簡易問診内容</li>
          <li>健康相談予約日時</li>
          <li>本サイトの操作履歴及び画面遷移</li>
        </ol>
      </li>
      <li>プライバシーポリシーの定めに拘わらず、当社は相談者本人の要配慮個人情報を、前項に定める目的のために取得します。</li>
      <li>相談により医師に提供される相談内容（個人情報の保護に関する法律に定める要配慮個人情報を含む。本条において同じ。）は、医師が当社指定の電子カルテシステムへ入力します。同一相談者本人が複数回相談する場合、前回と異なる医師が前回の相談内容を電子カルテシステムにより確認する場合があります。なお、当社はこの相談内容について第４条第４項に定める対応により意図せず知ってしまった場合を除き、原則把握関知しないものとします。</li>
      <li>前２項の定めに拘わらず、当社は、医師もしくは電磁的機械的手段により要配慮個人情報及び相談内容について本人を特定できない形に加工した情報を分析し、本条第２項の目的のために利用する場合があります。</li>
      <li>当社は、本サービスにより取得した個人情報について、プライバシーポリシー及び本条第２項に定める目的のため、本サービスに関連する当社の他のシステムやサービスに登録された情報と照合、分析、加工する場合があります。</li>
      <li>当社及び医師は、本サービスの利用結果及び相談結果により、相談者本人の状況が以下に該当し緊急性があると判断した場合（該当する可能性がある場合を含む。）には、消防や警察等の行政機関や関係機関（相談者本人が当社グループ会社従業員である場合には所属会社を含む。）へ通報や必要な要請を行う場合があります。
        <ol class="second-list">
          <li>法令に基づく場合</li>
          <li>第三者を含む人の生命、身体又は財産の保護のために必要がある場合</li>
          <li>公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合</li>
          <li>国の機関などの法令の定める事務の遂行に当社が協力する必要がある場合</li>
        </ol>
      </li>
      <li>本サイトでは、Google Analyticsを利用しています。ユーザー及び親族等が本サイト上で行った操作履歴及び画面遷移の情報について、当社はGoogle Analytics を通じて取得し、本サービスの利用状況の分析・調査・品質改善・ユーザーや親族等への対応向上、施策の効果測定のために利用します。Google Analyticsによるデータ使用の詳細は、<a href="https://www.google.com/intl/ja/policies/privacy/partners/" target="_blank">www.google.com/intl/ja/policies/privacy/partners/</a>をご参照ください。</li>
    </ol>
    <div class="term-sub-title">第１４条（個人情報の第三者提供）</div>
    <ol>
      <li>ユーザー及び相談者本人が当社のグループ会社に所属する者である場合、当社は、当社の定めるプライバシーポリシー等の定めに拘わらず、本サービスに係り以下に定める利用目的のため、以下の第三者へユーザーの個人情報を提供する場合があり、ユーザーは本サービスの利用にあたりこれに同意するものとします。
        <div class="top-padding">【提供の目的】</div>
        <div class="left-padding">前条第２項【利用目的】に定める目的並びにグループ会社における従業員の健康及び体調管理、職場の安全衛生管理のため</div>
        <div class="top-padding">【提供する情報】</div>
        <ol class="second-list">
          <li>ユーザー及び相談者本人の氏名・性別・年齢</li>
          <li>体温・症状報告内容</li>
          <li>出勤・在宅・休日等の予定</li>
          <li>滞在場所・時間（相談者本人の就業場所に当社指定の位置情報取得デバイス、ビーコンを設置している場合、これにより得られる情報）</li>
          <li>健康相談日時・相談時間</li>
          <li>予約時の相談者情報（名前・性別・年代・連絡先）</li>
          <li>予約時の相談カテゴリー、簡易問診内容</li>
          <li>健康相談予約日時</li>
        </ol>
        <div class="top-padding">【提供先】</div>
        <div class="left-padding">フリービット株式会社のグループ会社のうち、ユーザー及び相談者本人が所属するグループ会社。以下URLからご確認ください。</div>
        <a class="left-padding" href="https://freebit.com/profile/group.html" target="_blank">https://freebit.com/profile/group.html</a>
      </li>
      <li>ユーザー及び相談者本人が当社のグループ会社に所属する者の親族等である場合、当社は、当社の定めるプライバシーポリシー等の定めに拘わらず、本サービスに係り以下に定める利用目的のため、以下の第三者へ当該親族等の個人情報を提供する場合があり、当該親族等である相談者本人は本サービスの利用にあたりこれに同意するものとします。
        <div class="top-padding">【提供の目的】</div>
        <div class="left-padding">前条第２項【利用目的】（３）（４）（５）（６）に定める目的のため</div>
        <div class="top-padding">【提供する情報】</div>
        <ol class="second-list">
          <li>相談者本人の氏名・性別・年齢</li>
          <li>健康相談日時・相談時間</li>
          <li>予約時の相談者情報（名前・性別・年代・連絡先）</li>
          <li>予約時の相談カテゴリー、簡易問診内容</li>
          <li>健康相談予約日時</li>
        </ol>
        <div class="top-padding">【提供先】</div>
        <div class="left-padding">フリービット株式会社のグループ会社のうち、当該親族等と親族関係にあるユーザーが所属するグループ会社。以下URLからご確認ください。</div>
        <a class="left-padding" href="https://freebit.com/profile/group.html" target="_blank">https://freebit.com/profile/group.html</a>
      </li>
    </ol>
    <div class="term-sub-title">第１５条（知的財産権）</div>
    <ol>
      <li>本サービスに係る著作物（文書、写真、イラスト、映像、音楽、ソフトウエア等）の著作権（著作権法第２７条及び第２８条の権利を含む。）は、当社又は第三者が保有しており、著作権法上認められている範囲を除き、著作権者の承諾なしにこれらの著作物を複製、販売、出版、公衆送信等することはできません。</li>
      <li>本規約は、著作権（著作権法第２７条及び第２８条の権利を含む。）その他知的財産権について、いかなる使用や処分についてもユーザー及び親族等に対し許諾するものではありません。</li>
      <li>当社は、本サービスの利用についてアンケートを実施する場合があります。当該アンケートに対しユーザー及び相談者本人が回答した内容について、当社は、事前に通知することなく、かつ、その理由を開示することなく、削除、訂正、修正、改変、編集若しくは複製し、又は、本サービスの宣伝若しくは利用促進等の目的で当社が別途指定する媒体に掲載する等、自由に利用することができるものとします。ユーザー及び親族等は、当社、当社のグループ会社及び当社が別途指定する第三者に対して著作者人格権（公表権、氏名表示権、同一性保持権）を一切行使せず、また、著作権法第２７条及び第２８条の権利を含む著作権の侵害その他の権利侵害を一切主張しないものとします。</li>
    </ol>
    <div class="term-sub-title">第１６条（免責）</div>
    <ol>
      <li>ユーザー及び親族等は本サービスを専ら自らの責任において利用するものとし、当社は、本サービスにおいて当社もしくは医師が提供する情報について、その正確性、適法性、完全性、有用性など、いかなる保証も行いません。</li>
      <li>第三者がユーザーもしくは親族等を騙り本サービスを利用した場合、当社は、ユーザーもしくは親族等本人による本サービスの利用がなされたものとみなすものとし、当該第三者による利用について当社は免責されます。</li>
      <li>当社は、本サービスのウェブページ、サーバ、ドメイン等から送られるメール、本サービス内のコンテンツ等に、コンピュータウイルス等の有害なものが含まれないことを保証いたしません。</li>
      <li>当社は、本サービスの利用に関しユーザー及び親族等に生じた損害について、当社の故意又は重過失に帰すべき場合を除き、いかなる場合も負わないものとします。</li>
      <li>天災地変、法令・行政指導・監督官庁の指導、障害事由、その他不可抗力等により本サービスを提供することができない場合には、当社は本サービスの提供責任を免除されるものとします。</li>
      <li>通信回線やコンピューター等の障害によるシステムの中断・遅滞・中止・データの消失、データへの不正アクセスにより生じた損害、その他本サービスの利用に関してユーザーに生じた損害について、当社は一切責任を負わないものとします。</li>
      <li>本サービスのほか、他社が提供し当社の使用する電子カルテシステムにより発生するユーザー及び親族等の損害等について、当社は一切責任を負いません。</li>
      <li>当社とユーザー及び親族等との関係において消費者契約法等、関係法令により当社の免責が無効とされる場合、本条は無効とします。この場合当社が負う責任は、次条に定める範囲を上限とします。</li>
    </ol>
    <div class="term-sub-title">第１７条（損害賠償）</div>
    <ol>
      <li>ユーザー及び親族等は、本サービスの利用に関し、自己の責めに帰すべき事由により、当社およびその他第三者に対して損害を与えた場合、これを賠償する責任を負います。</li>
      <li>当社がユーザー及び親族等や第三者に対して責任を負う場合、当社に故意又は重大な過失がある場合を除き、当社が負う損害賠償の範囲は、通常生ずべき損害、及び特別の事情によって生じた損害のうち履行時においてその事情を予見し又は予見することができた範囲とします。</li>
      <li>前2項の賠償には、損害を与えた相手方に対して履行を求める一切の費用、訴訟等裁判手続きに関する合理的な専門家費用の相当額を含むものとします。</li>
    </ol>
    <div class="term-sub-title">第１８条（分離可能性）</div>
    <div class="left-padding">本規約のいずれかの条項又はその一部が、消費者契約法その他の法令等により無効又は執行不能と判断された場合であっても、本規約の残りの規定及び一部が無効又は執行不能と判断された規定の残りの部分は、継続して完全に効力を有するものとします。また、本規約の一部があるユーザー及び親族等との関係で無効とされ、又は取り消された場合でも、本規約はその他のユーザーとの関係では有効とします。なお、本規約中の規定に法的拘束力がないとして判示されるものがあった場合、当該規定は、当該規定を法的に拘束力を備えたものにするために必要な範囲を限度としてのみ、補正するものとします。</div>
    <div class="term-sub-title">第１９条（協議）</div>
    <div class="left-padding">本規約に定めのない事項、又はその解釈に疑義を生じた事項については、ユーザー及び親族等と当社が誠実に協議し、その解決を図るものとします。</div>
    <div class="term-sub-title">第２０条（管轄）</div>
    <div class="left-padding">本規約は日本国法を準拠法とし、本規約および本サービスに関し訴訟が生じた場合、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</div>
    <div class="term-sub-title">附則</div>
    <div>本規約は、2022年3月8日から実施します。</div>
  </div>
</template>

<script>
export default {
  name: 'Term'
}
</script>

<style scoped>
.term {
  margin: 64px 32px;
}
.term-title {
  text-align: center;
  font-size: 16pt;
  margin: 24px 0;
}
.term-sub-title {
  margin-top: 32px;
  margin-bottom: 8px;
  font-weight: bold;
}
.second-list {
  margin-left: 32px;
}
.second-list li {
  list-style-type: none;
  counter-increment: cnt;
}
.second-list li::before {
  content: "(" counter(cnt) ") ";
  display:inline-block;
  margin-left:-2.7em;
  width: 2.2em;
  margin-right: 0.5em;
  text-align: right;
}

.top-padding {
  margin-top: 24px;
}

.left-padding {
  margin-left: 24px;
}
.indent {
  text-indent: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Term.vue